export function moment(date, format) {
    return window.moment(new Date(date)).format(format ? format : 'DD MMMM YYYY');
}

export function momentRev(date) {
    return window.moment(new Date(date?.split('-')[2], date?.split('-')[0] - 1, date?.split('-')[1]));
}

/* eslint-disable no-extend-native  */
/**
 *  replaceSpace is function to replace space (' ') with datsh ('-')
 *  @returns {string} - the new stirng after replacing space
 */
String.prototype.replaceSpace = function () {
    var str = this;
    // for (let i = 0; i < this.length; i++) {
    //     if (this[i] === ' '){
    //         str = str.replace(' ', '-')
    //     }
    // }
    return str.replace(/ /gi, '-');
}

/**
 *  replaceCharWith is function to replace any character with anothor one for all the string
 *  @param {string} character - the string contain have to be one character
 *  @param {string} newCharacter - the string contain have to be one character
 *  @returns {string} - the new stirng after replacing the character
 */
String.prototype.replaceChar = function (character, newCharacter) {
    var str = this;
    for (let i = 0; i < this.length; i++) {
        if (this[i] === String(character)) {
            str = str.replace(String(character), String(newCharacter))
        }
    }
    return str
}
/* eslint-enable no-extend-native  */